import classNames from 'classnames'

import AiRingIcon from './AiRingIcon'

// Tailles de la marque IA — icône (px), classes du badge, gap.
const sizes = {
    sm: { icon: 14, badge: 'px-1 py-0.5 text-[9px]', gap: 'gap-1' },
    md: { icon: 16, badge: 'px-1.5 py-0.5 text-[10px]', gap: 'gap-1.5' },
    lg: { icon: 20, badge: 'px-1.5 py-0.5 text-[11px]', gap: 'gap-2' },
    xl: { icon: 26, badge: 'px-2 py-1 text-sm', gap: 'gap-2.5' },
}

// Marque IA du backoffice : icône burst + petit badge "AI".
// Composant unique à poser sur toute surface assistée / générée par IA.
// `size`: 'sm' | 'md' | 'lg' | 'xl', ou un nombre (px) pour l'icône.
export default function AiMark({ size = 'md', className }) {
    const preset = typeof size === 'number' ? null : sizes[size] || sizes.md
    const iconSize = preset ? preset.icon : size
    const badgeClasses = preset ? preset.badge : sizes.md.badge
    const gapClass = preset ? preset.gap : sizes.md.gap

    return (
        <span
            className={classNames(
                'inline-flex items-center text-zinc-900 select-none',
                gapClass,
                className
            )}
        >
            <AiRingIcon width={iconSize} height={iconSize} />

            <span
                className={classNames(
                    'inline-flex items-center rounded-[5px] bg-zinc-900 font-bold uppercase leading-none tracking-wide text-white',
                    badgeClasses
                )}
            >
                IA
            </span>
        </span>
    )
}
